import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import fastclick from 'fastclick'

import '@/assets/css/transition.less'
import '@/assets/css/comm.css'

import {get,post,put,del} from '@/assets/js/api'
import {tools} from '@/assets/js/tools'

Vue.config.productionTip = false

Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$put = put
Vue.prototype.$delete = del

Vue.prototype.$tools = tools

fastclick.attach(document.body)

new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js